module.exports = __webpack_public_path__ + "img/pic_huaweistepthree.37889082.png";